import FeatureCodes from '../enums/feature-codes';
import { FeatureUsage } from '../types/feature-usage';

export const getFeatureCodeValue = (
  featureUsages: FeatureUsage[],
  code: FeatureCodes,
) => featureUsages.find(({ featureCode }) => featureCode === code);
